import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { NoAssetsAddedDesktopAsset } from "~/components/ContributableNullState/NoAssetsAddedDesktopAsset";
import { NoAssetsAddedMobileAsset } from "~/components/ContributableNullState/NoAssetsAddedMobileAsset";
import { NullState } from "~/components/NullState";
export const NonContributableEmptyState = /*#__PURE__*/ memo((param)=>{
    let { description = "Check back later to see if anything has been uploaded to this board.", title = " Nothing to see here, yet…" } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    return /*#__PURE__*/ _jsx(NullState, {
        testId: "NON_CONTRIBUTABLE_EMPTY_STATE",
        image: /*#__PURE__*/ _jsx("div", {
            children: isAboveMediumScreen ? /*#__PURE__*/ _jsx(NoAssetsAddedDesktopAsset, {
                className: "mx-auto -mb-4 w-full"
            }) : /*#__PURE__*/ _jsx(NoAssetsAddedMobileAsset, {
                className: "mx-auto"
            })
        }),
        title: title,
        description: description
    });
});
NonContributableEmptyState.displayName = "NonContributableEmptyState";
